// extracted by mini-css-extract-plugin
module.exports = {"NotFoundError":"of_a pz_mo pz_a pz_w pz_j pz_q","NotFoundError__icon":"of_b pz_qw pz_fa pz_oj","NotFoundError__icon__image":"of_c","NotFoundError__message":"of_e pz_fa pz_pe"};